import { render, staticRenderFns } from "./RouteTrips.vue?vue&type=template&id=5b6d8f3f&"
import script from "./RouteTrips.vue?vue&type=script&lang=js&"
export * from "./RouteTrips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports